module.exports = __webpack_public_path__ + "img/selected0-min.71ccf3d4.png";